import { applyPhoneEdit, formatPhoneDisplay } from "@/shared/utils";
import { Input } from "../Input";

interface Props {
  value: string | undefined | null;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  hasRequiredLabel?: boolean;
  id?: string;
  name?: string;
  onBlur?: () => void;
}

export default function PhoneInput({
  value,
  onChange,
  label,
  placeholder = "(___) ___-__-__",
  error,
  disabled = false,
  hasRequiredLabel = false,
  id,
  name,
  onBlur,
}: Props) {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const el = e.target;
    const edit = applyPhoneEdit(el.value, el.selectionStart ?? el.value.length, value);
    onChange(edit.value);
    requestAnimationFrame(function restoreCaret() {
      el.setSelectionRange(edit.caret, edit.caret);
    });
  }

  return (
    <Input
      label={label}
      placeholder={placeholder}
      icon={<span className="text-body-regular-sm content-base-primary select-none">+7</span>}
      className="pl-8!"
      value={formatPhoneDisplay(value)}
      onChange={handleChange}
      onBlur={onBlur}
      error={error}
      disabled={disabled}
      hasRequiredLabel={hasRequiredLabel}
      id={id}
      name={name}
      inputMode="tel"
      autoComplete="off"
    />
  );
}
